export default __webpack_public_path__ + "static/material_04-15ba2380d6f4836f1f67e71fa978721c.png";